module.exports = "/images/bixia_ab.png?41a57a2b1736778ab45af3bdc399c633";